<template>
    <div id="q-info">
        <span class="mdi mdi-close icon-scale bigger close-button"
              @click="$emit('close')"
               :style="{fontSize:dialogCloseFont}">
        </span>
        <div class="has-text-centered q-info-header">
            <p  :style="{fontSize:dialogTitleFont}">ขั้นตอนการเข้ารับบริการ</p>
            <p class="q-info-sub-header"  :style="{fontSize:dialogUnitFont}" >{{ serviceUnitName }}</p>
        </div>
        <div class="has-text-centered instruction-item"
         :style="{fontSize:dialogInstructionsFont}"
             v-for="(item, index) in instructions"
             :key="index">
            <img v-if="tryLoadImage(item.iconPath)"
                 :src="require(`@/assets/img/${item.iconPath}`)"
                 alt="" />
            <br>
            {{ index+1 }}. {{ item.title }}
        </div>
    </div>
</template>

<script>

const props = {
  instructions: {
    type: Array,
    default: []
  },
  serviceUnitName: {
    type: String,
    default: ''
  }
}

export default {
  name: 'qInstructionPopup',
  props,
  methods: {
    tryLoadImage (path) {
      try {
        require(`@/assets/img/${path}`)
      } catch {
        return false
      }
      return true
    }
  },
  mounted () {
    if (this.isEmbedded) {
      this.dialogTitleFont = '3.25rem'
      this.dialogCloseFont = '3em'
      this.dialogUnitFont = '3rem'
      this.dialogInstructionsFont = '3rem'
    }
  },
  data () {
    return {
      isEmbedded: process.env.VUE_APP_EMBEDDED === 'true',
      dialogTitleFont: '',
      dialogCloseFont: '',
      dialogUnitFont: '',
      dialogInstructionsFont: ''
    }
  }

}
</script>

<style lang="scss" scoped>
  #q-info {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem 1.25rem;
    margin: 1rem;
    overflow-y: scroll;
    max-height: 80vh;

    .q-info-header {
      font-size: 1.25rem;
      font-family: 'Mitr', sans-serif;
      color: #707070;

      .q-info-sub-header {
        font-weight: 300;
        font-size: 1rem;
      }
    }

    .instruction-item {
      font-size: 1rem;
      font-weight: bold;
      color: #6e6e6e;
      margin-top: 1rem;
    }
  }
</style>
